import type { IUserSession } from '@repo/auth';
import type { AppSidebarData } from '@repo/ui';

export function getUserDetails(session: IUserSession | null): AppSidebarData['user'] {
  return {
    name: session?.user?.name || 'User',
    email: session?.user?.email || '',
    avatar: session?.user?.image || '',
  };
}
